<template>
    <div>
        <div class="form-inline" v-for="(selection,idx) in dateSelections">
            <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                    <label class="input-group-text" :for="'date_' + idx">Datum</label>
                </div>
                <datepicker :language="de" :disabled-dates="dateConfig.disabledDates" :id="'datetime_' + idx" type="date" v-model="selection.date"
                       :name="'appointment_dates[' + idx + '][date]'" :input-class="'form-control bg-white'" required :format="'dd.MM.yyyy'"/>
            </div>
            <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                    <label class="input-group-text" :for="'time_' + idx">Uhrzeit</label>
                </div>
                <input :id="'time_' + idx" type="time" class="form-control" v-model="selection.time"
                       :name="'appointment_dates[' + idx + '][time]'" min="08:00" max="20:00" required/>
            </div>
            <button type="button" class="btn btn-danger mb-2" v-on:click="removeDate(idx)">Datum löschen</button>
        </div>

        <button :disabled="dateSelections.length >= maxDates" type="button" class="btn btn-success mb-4 d-block" v-on:click="addDate">Datum hinzufügen</button>
    </div>
</template>
<script>
    import VueDatePickerDe from 'vuejs-datepicker/dist/locale/translations/de';
    export default {
        name: 'date-editor',
        props: {
            'maxDates': {
                type: Number,
                default: 2
            },
            'dates': {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data() {
            return {
                de: VueDatePickerDe,
                'dateSelections': this.dates,
                dateConfig: {
                    disabledDates: {
                        to: new Date(moment(Date.now()).add(2, 'day').format('YYYY, MM, DD')),
                        from: new Date(moment(Date.now()).add(4, 'month').format('YYYY, MM, DD'))
                    }
                }
            }
        },
        methods: {
            addDate: function () {
                if (this.maxDates && this.dateSelections.length < this.maxDates) {
                    this.dateSelections.push({date: this.minDate, time: '12:00'});
                }
            },
            removeDate: function (idx) {
                this.$delete(this.dateSelections, idx);
            },
            formatDate: function(date){
                return moment(date).format('YYYY-MM-DD');
            }
        },
        computed: {
            minDate: function () {
                return this.$moment().add(3, 'days').format('YYYY-MM-DD');
            }
        },
        mounted() {
            this.addDate();
        },
        watch: {
            dateSelections() {
                this.$emit('input', this.dateSelections)
            }
        }
    }
</script>
